import React, { FC } from 'react'

import { CheckboxWithTxt } from 'src/components/molecules'

type Props = {
  type: 'internal' | 'external'
  isSendEmail: boolean
  checkboxPosition?: 'left' | 'right'
  updateCheck: (newValue: boolean) => void
  className?: string
}

export const SendPasswordMailCheckbox: FC<Props> = ({
  type,
  isSendEmail,
  checkboxPosition = 'left',
  updateCheck,
  className,
}) => {
  return (
    <div className={className}>
      <CheckboxWithTxt
        text={type === 'internal' ? '仮パスワード発行メールを送信' : 'パスワード発行メールを送信'}
        checked={isSendEmail}
        checkboxPosition={checkboxPosition}
        onClick={() => updateCheck(!isSendEmail)}
      />
    </div>
  )
}
